module.exports = __webpack_public_path__ + "img/element_3.03071b4b.png";